import { useCallback } from "react";
import { useNavigate } from "react-router";

import {
  POLICY_ISSUANCE_POLL_INTERVAL,
  POLICY_ISSUANCE_POLL_TIMEOUT_DURATION,
} from "@covertree/consts";
import { useGetDecPageQuery } from "@covertree/new-business-graphql";
import {
  hideLoadingFrame,
  selectPolicy,
  showLoadingFrame,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";

import { useAppDispatch } from "@redux/hooks";
import { navigateToPolicyStep, NewPolicyRoutes } from "@routing/paths";
import { CongratulationsView } from "./CongratulationsView";
import { usePolling } from "@covertree/hooks/hooks/usePolling";

export function CongratulationsStep() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { policyLocator } = useNewBusinessSelector(selectPolicy);

  const callback = useCallback(
    (pollInterval: number) =>
      useGetDecPageQuery({
        fetchPolicy: "network-only",
        pollInterval: pollInterval,
        variables: { policyLocator },
      }),
    []
  );

  const onPolling = useCallback(() => {
    dispatch(
      showLoadingFrame({
        messages: ["Generating documents", "Congratulations!"],
        maxLoadTime: 15,
      })
    );
  }, [dispatch]);

  const onSuccess = useCallback(() => {
    dispatch(hideLoadingFrame());
  }, [dispatch]);

  const onError = useCallback(() => {
    navigateToPolicyStep(
      navigate,
      NewPolicyRoutes.ERROR,
      NewPolicyRoutes.CONGRATULATIONS,
      dispatch,
      undefined,
      true
    );
  }, [navigate]);

  const { data, isPolling } = usePolling({
    blockNavigationWhenPolling: true,
    pollInterval: POLICY_ISSUANCE_POLL_INTERVAL,
    timeoutDuration: POLICY_ISSUANCE_POLL_TIMEOUT_DURATION,
    callback,
    onSuccess,
    onPolling,
    onError,
  });

  if (isPolling) {
    return null;
  }

  return <CongratulationsView decPageUrl={data.getDecPage} />;
}
